import { makeStyles } from '@material-ui/core';
import colors from './colors';
import themeStyle from './theme';

export const emptyStateStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2)
  },
  icon: {
    background: colors.backgrounds.primary,
    width: theme.spacing(5),
    height: theme.spacing(5),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  textbox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    ...themeStyle.typography.mdRegular,
    color: colors.gray[600]
  },
  subtitle: {
    ...themeStyle.typography.smMedium,
    color: colors.gray[500]
  }
}));
